// extracted by mini-css-extract-plugin
export default {"btn":"pNOGAbSzdgJZQ30P9qae"};